import { useEffect } from 'react'

import { UseIonRouterResult, useIonRouter } from '@ionic/react'
import { InfoWindowF, MarkerF } from '@react-google-maps/api'
import moment from 'moment'

import { capitalize, createString, getUserFullName } from '../../../../helpers/helpers'
import { IEventInterface } from '../../../../models/events/event.interface'
import {
  selectMapFocusedMarkerIdR,
  setMapFocusedMarkedIdAc,
  setMapLoadingAc,
} from '../../../../store/filters/filterSlice'
import { useAppDispatch, useAppSelector } from '../../../../store/hooks'
import { selectOrganizers } from '../../../../store/organizers/organizersSlice'
import { selectEvents } from '../../../../store/events/eventsSlice'

type IProps = {
  onEventMarkerClick: (router: UseIonRouterResult, eventId: IEventInterface['id']) => void
  isOrganizers?: boolean
  searchedLocation: {
    lat: number
    lng: number
  } | null
}

const Markers = ({ onEventMarkerClick, searchedLocation, isOrganizers }: IProps) => {
  const dispatch = useAppDispatch()

  // Hooks and vars
  const router = useIonRouter()

  const organizers = useAppSelector(selectOrganizers)
  const allEventsR = useAppSelector(selectEvents)
  const focusedMarkedId = useAppSelector(selectMapFocusedMarkerIdR)

  useEffect(() => {
    if (allEventsR.status === 'loading') {
      dispatch(setMapLoadingAc(true))
    } else {
      dispatch(setMapLoadingAc(false))
    }
  }, [allEventsR.status])

  return (
    <>
      {searchedLocation ? (
        <MarkerF
          position={{
            lat: searchedLocation.lat,
            lng: searchedLocation.lng,
          }}
          title="Home"
          icon="/assets/og_icons/markerIcon.svg"
        />
      ) : null}

      {isOrganizers
        ? organizers.map((organizer) => (
            <div key={organizer.id}>
              <MarkerF
                onMouseOut={() => dispatch(setMapFocusedMarkedIdAc(null))}
                onMouseOver={() => dispatch(setMapFocusedMarkedIdAc(organizer.id))}
                position={{
                  lat: Number(organizer.userLat),
                  lng: Number(organizer.userLong),
                }}
                onClick={() => onEventMarkerClick(router, organizer.id)}
                icon="/assets/cp_icons/FinalMapPin.svg"
              >
                {focusedMarkedId === organizer.id && (
                  <InfoWindowF
                    position={{
                      lat: Number(organizer.userLat),
                      lng: Number(organizer.userLong),
                    }}
                  >
                    <div className="marker-tooltip">{getUserFullName(organizer)}</div>
                  </InfoWindowF>
                )}
              </MarkerF>
            </div>
          ))
        : allEventsR.data.map((currEvent) => {
            if (!currEvent.competitionLat || !currEvent.competitionLong) return null

            return (
              <div key={JSON.stringify(currEvent)}>
                <MarkerF
                  onMouseOut={() => dispatch(setMapFocusedMarkedIdAc(null))}
                  onMouseOver={() => dispatch(setMapFocusedMarkedIdAc(currEvent.id))}
                  position={{
                    lat: Number(currEvent.competitionLat),
                    lng: Number(currEvent.competitionLong),
                  }}
                  onClick={() => onEventMarkerClick(router, currEvent.id)}
                  icon="/assets/cp_icons/FinalMapPin.svg"
                >
                  {focusedMarkedId === currEvent.id && (
                    <InfoWindowF
                      position={{
                        lat: Number(currEvent.competitionLat),
                        lng: Number(currEvent.competitionLong),
                      }}
                    >
                      <div className="marker-tooltip">
                        {capitalize(
                          createString([
                            currEvent.category,
                            currEvent?.tags?.find((tag) => tag === 'All')
                              ? 'All Disciplines'
                              : currEvent.tags?.toString(),
                            currEvent.registrationOpenDate
                              ? moment(currEvent.registrationOpenDate).format('MMM D')
                              : '',
                          ])
                        )}
                      </div>
                    </InfoWindowF>
                  )}
                </MarkerF>
              </div>
            )
          })}
    </>
  )
}

export default Markers
